import { ParameterValidator } from '@mvps-genesis/utilities';
import Message from './Message';

export default class MessageContainer {

	// define "private" properties
	_validator;

	// define "public" properties
	messages = [];
	container;
	currentMessage;

	constructor({
		container = '#js-messages'
	} = {}) {

		// create validator
		this._validator = new ParameterValidator( this );

		// define container element (optional)
		this.container = this._validator.isElement( 'container', container, { required: false } );

		// bind any events that need to be attached
		this.bindEvents();

		// if container is set then bootstrap the messages
		if ( this.container ) {
			this.instanceMesagesFromContainer();
		}

	}

	bindEvents() {}

	instanceMesagesFromContainer() {

		const messages = this.container.getElementsByClassName( Message.classes.root );

		for ( let message of messages ) {

			this.messages.push( Message.fromHTML( message ) );

		}

	}

	add( message ) {

		// validate message type
		this._validator.isInstance( 'message', message, Message );
		
		// set current message property
		this.currentMessage = message;

		// add to message array
		this.messages.push( message );

		// add to html container
		if ( this.container ) {
			this.container.appendChild( message.render() );
		}

	}

	remove( message ) {

		// validate message type
		this._validator.isInstance( 'message', message, Message );

		// remove from messages array
		this.messages = this.messages.filter( ( m ) => m.id !== message.id );

		// remove from html container
		if ( this.container ) {
			this.container.removeChild( this.container.children.namedItem( message.id ) );
		}

		// set current message property
		this.currentMessage = this.messages[ (this.messages.length - 1) ];

	}

	clear() {

		this.currentMessage = undefined;

		this.messages = [];
		
		if ( this.container ) {
			this.container.innerHTML = '';
		}
			
	}

};